import React from 'react';
import { Card } from '../../index';
import './linked_card.scss';

export const LinkedCard = ({
    children,
    className = '',
    disabled = false,
    hoverStyle = 'default',
    href,
    to,
    onClick,
    target,
}) => {

    const linkedCardClasses = [
        `mybswh-linked-card`,
        `mybswh-linked-card--hover-${hoverStyle}`,
        `${className ? className : ''}`
    ].join(' ');

    return (
        <Card
            className={linkedCardClasses}
            disabled={disabled}
            href={href}
            target={target}
            to={to}
            onClick={onClick}
        >
            {children}
        </Card>
    )
};